import React from "react";
import Emergency from "../../components/views/Emergency";
import firebase from "../../../services/firebase";

const DB = firebase.db;

class EmergencyCliente extends React.Component {
    constructor(props) {
        super();
        this.state = {
            restaurants: [],
            loader: false,
        };
        this.handleClick = this.handleClick.bind(this);

    }

    componentDidMount() {
        window.scrollTo(0, 0);

    }

    handleClick(type) {
        if (type === "add") {
            //agregar accion de proveedores.
        }
    }

    render() {
        return (
            <div>
                <Emergency
                    restaurants={this.state.restaurants}
                    loader={this.state.loader}
                    screenSize={window.screen.width}
                    handleClick={this.handleClick}
                />
            </div>
        );
    }
}

export default EmergencyCliente;
